import { z } from "zod";

import { Nist } from "api/memberPortal/certReview/certReview.types";
import { Ear } from "api/memberPortal/ear/ear.types";
import { Note } from "api/memberPortal/notes/notes.types";
import { Maintenance } from "api/memberPortal/project/maintenance/maintenance.types";
import { Product } from "api/memberPortal/project/product/product.types";
import { ProtectionProfile } from "api/memberPortal/project/protectionProfiles/protectionProfile.types";
import { TechnicalQuery } from "api/memberPortal/technicalQueries/technicalQueries.types";

interface BaseFormProps {
  show: boolean;
  handleClose: () => void;
  note: Note;
  replyTo?: Note;
}

export interface AMNoteFormProps extends BaseFormProps {
  maintenance: Maintenance;
}

export interface PPNoteFormProps extends BaseFormProps {
  protectionProfile: ProtectionProfile;
}

export interface ProductNoteFormProps extends BaseFormProps {
  product: Product;
}

export interface TQNoteFormProps extends BaseFormProps {
  tq: TechnicalQuery;
}

export interface NistNoteFormProps extends BaseFormProps {
  nist: Nist;
}

export interface EarNoteFormProps extends BaseFormProps {
  earReview: Ear;
}

// for note forms that only check Is Private
export interface InternalOnlyNoteFormValues {
  internal_only: boolean;
  title?: string | null;
  note: string;
}

export interface BaseNoteFormValues {
  title?: string | null;
  note: string;
}

// for note forms that check Is Private and visibility to Labs/Validators
export interface LabValidatorInternalNoteFormValues extends BaseNoteFormValues {
  visible_to_labs: boolean;
  visible_to_validators: boolean;
  internal_only: boolean;
}

// for note forms that check visibility to Labs/Validators/SMEs
export interface LabValidatorSmeNoteFormValues extends BaseNoteFormValues {
  visible_to_labs: boolean;
  visible_to_validators: boolean;
  visible_to_smes: boolean;
}

export interface LabNoteFormValues extends BaseNoteFormValues {
  visible_to_labs: boolean;
}

export const BaseNoteFormSchema = z.object({
  title: z.string().nullable().optional(),
  note: z.string().min(1, "Note is required"),
});

export const InternalOnlyNoteFormSchema = BaseNoteFormSchema.extend({
  internal_only: z.boolean(),
});

export const LabValidatorInternalNoteFormSchema = BaseNoteFormSchema.extend({
  internal_only: z.boolean(),
  visible_to_labs: z.boolean(),
  visible_to_validators: z.boolean(),
});

export const LabValidatorSmeNoteFormSchema = BaseNoteFormSchema.extend({
  visible_to_labs: z.boolean(),
  visible_to_validators: z.boolean(),
  visible_to_smes: z.boolean(),
});

export const LabNoteFormSchema = BaseNoteFormSchema.extend({
  visible_to_labs: z.boolean(),
});
